import { FrameAgreement } from "../frame-agreement.model";
import { AuthwayOrganizationInfo } from "../organization/authway-organization-info.model";

export class OrganizationSelection{

  constructor(jsonObject: any = null) {
      if (jsonObject == null) {
        return;
      }
  
      this.frameAgreement = jsonObject.frameAgreement ? new FrameAgreement(jsonObject.frameAgreement) : null;
      this.tenant = jsonObject.tenant ? new AuthwayOrganizationInfo(jsonObject.tenant) : null;
    }

  frameAgreement: FrameAgreement = null;
  tenant: AuthwayOrganizationInfo = null;

  get isEmpty(){
    return this.frameAgreement == null && this.tenant == null;
  }

  isEqual(compare: OrganizationSelection){
    return this.frameAgreement?.id == compare?.frameAgreement?.id && this.tenant?.tenantId == compare?.tenant?.tenantId;
  }
}